import { Node, mergeAttributes } from '@tiptap/core';
import { paramLabel, paramTag } from '../data/templateModes';

/**
 * A merge-tag chip in the scratch pad: one inline, atomic node per vendor field, shown as a
 * pill reading "Company name" and saved as {{params.company_name}} (templateModes.withParamTags).
 * Atomic, so an operator can delete or move it but never type inside it and break the tag.
 */
export const ParamChip = Node.create({
  name: 'paramChip',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      key: {
        default: 'company_name',
        parseHTML: (el) => el.getAttribute('data-param'),
        renderHTML: (attrs) => ({ 'data-param': attrs.key }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-param]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        class: 'sp-param',
        contenteditable: 'false',
        title: `Filled in per vendor at send time: ${paramTag(node.attrs.key)}`,
      }),
      paramLabel(node.attrs.key),
    ];
  },

  renderText({ node }) {
    return paramTag(node.attrs.key);
  },

  addCommands() {
    return {
      insertParam:
        (key) =>
        ({ chain }) =>
          chain()
            .insertContent([{ type: this.name, attrs: { key } }, { type: 'text', text: ' ' }])
            .run(),
    };
  },
});

export default ParamChip;
